module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_25_30.8b57503d.png";